import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/review/')({
  component: ReviewIndexPage,
});

function ReviewIndexPage() {
  return <div>TODO: Review Submission</div>;
}
